import type {HourOfTheDay, MinuteOfTheHour} from '../Time';
import type {Start} from './ScheduleIndex';

export default function createStart(
  hour: HourOfTheDay,
  minute: MinuteOfTheHour,
): Start {
  return `${hour.toString(10).padStart(2, '0')}:${minute.toString(10).padStart(2, '0')}` as Start;
}
